<script>
import Vue from 'vue'

export default {
  inject: ['hxForm'],

  props: {
    col: [Number, String],
    name: String,
    formModel: Object,
    labelWidth: String,
    labelPosition: String,
  },

  data() {
    return {}
  },

  mounted() {
    if (this.name) {
      const itemInstance = this.$refs[this.name]
      this.hxForm.$emit('hx.form.addField', itemInstance, this.name)
    }

    this.hxForm.$emit('hx.form.addFormItem', this)
  },

  beforeDestroy() {
    this.hxForm.$emit('hx.form.removeField', this.$refs[this.name], this.name)

    this.hxForm.$emit('hx.form.removeFormItem', this)
  },

  render() {
    const {
      type = 'HxInput',
      render,
      child,
      props = {},
      tip,
      required,
      disabled,
      label,
      prop,
      rules,
      uuid,
      ...formItemProps
    } = this.$attrs

    let tipDisabled = true

    if (
      this.labelPosition === 'left' &&
      this.labelWidth === '120px' &&
      +this.col === 4 &&
      label &&
      label.length > 8
    ) {
      tipDisabled = false
    }

    if (
      this.labelPosition === 'right' &&
      this.labelWidth === '85px' &&
      +this.col === 4 &&
      label &&
      label.length > 5
    ) {
      tipDisabled = false
    }

    if (tip) {
      tipDisabled = false
    }

    const RenderComponent = type

    const scopedSlots = {
      default: () => {
        const {
          on = {},
          events = {},
          ...other
        } = Object.assign({}, child || props, formItemProps)
        const firstOn = Object.keys(other).reduce((pre, cur) => {
          const arr = cur.trim().split('on')
          if (arr[0] === '' && arr[1]) {
            const eventName = arr[1].toLocaleLowerCase()
            pre[eventName] = other[cur]
          }
          return pre
        }, {})

        const listeners = Object.assign({}, firstOn, events, on)

        if (RenderComponent === 'HxTitle' || RenderComponent === 'hx-title') {
          listeners.downUp = (show) => {
            this.hxForm.$emit('hx.form.hxTitleDownUp', show, uuid)
          }
        }

        return (
          <RenderComponent
            ref={this.name}
            vModel={this.formModel[prop]}
            {...{
              props: { disabled, ...other },
              on: listeners,
              attrs: { ...other },
              ...props,
            }}
          >
            {props.scopedSlots && props.scopedSlots.default
              ? props.scopedSlots.default()
              : null}
          </RenderComponent>
        )
      },
      label: () => {
        return (
          <el-tooltip
            placement="top"
            effect="light"
            content={label}
            disabled={tipDisabled}
          >
            <span>{label}</span>
          </el-tooltip>
        )
      },
    }

    if (render) {
      scopedSlots.default = render
    }

    let mergeRules = []
    if (required) {
      const requiredDefault = { required: true }
      mergeRules.push(requiredDefault)
    }

    if (Object.prototype.toString.call(rules) === '[object Array]') {
      mergeRules = mergeRules.concat(rules)
    }

    if (Object.prototype.toString.call(rules) === '[object Object]') {
      mergeRules.push(rules)
    }

    if (mergeRules) {
      mergeRules.forEach((r) => {
        if (r.required && typeof r.message === 'undefined') {
          r.message = `${label}不能为空`
        }
      })
    }

    if (!label) {
      const item = scopedSlots.default()

      return item
    }

    return (
      <el-form-item
        class="hx-form-item"
        scopedSlots={scopedSlots}
        label={label}
        prop={prop}
        rules={mergeRules}
        {...{ props: formItemProps }}
      />
    )
  },
}
</script>
